import Image from 'next/image'

function BlogFeaturedImage({ post, size = 'normal' }) {
    let thumbnail_url
    if (size == 'small' && post?.featured_images?.['thumb-small']) {
        thumbnail_url = post.featured_images['thumb-small']
    } else if (size == 'medium' && post?.featured_images?.['thumb-standard']) {
        thumbnail_url = post.featured_images['thumb-standard']
    } else {
        thumbnail_url = post.jetpack_featured_media_url
    }

    const imageProps =
        size == 'small'
            ? {
                  width: 80,
                  height: 80,
              }
            : {
                  layout: 'fill',
                  objectFit: 'cover',
              }

    return thumbnail_url ? (
        <Image
            src={thumbnail_url}
            alt={
                post._embedded &&
                post?._embedded['wp:featuredmedia'][0]?.alt_text
            }
            title={
                post._embedded &&
                post?._embedded['wp:featuredmedia'][0]?.title?.rendered
            }
            {...imageProps}
            className="rounded-lg"
        />
    ) : (
        <div className="absolute min-h-16 w-full inset-0 border flex items-center justify-center text-gray-500">
            No Image Available
        </div>
    )
}

export default BlogFeaturedImage
